import { Component, OnInit, signal } from '@angular/core'
import { CallsApiClient, Client, CallLog, Patient, Reminder, CampaignInfo, Disposition, CallLogHistoryItem } from '../shared/services/ppv.api'
import moment from 'moment'
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { forkJoin } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { PhoneNumber } from '../shared/models/PhoneNumber'

@Component({
   selector: 'app-calls',
   templateUrl: './calls.component.html',
   styleUrls: ['./calls.component.scss'],
   standalone: false,
})
export class CallsComponent implements OnInit {
   public client: Client
   public callLog: CallLog
   public isLoading: boolean = true
   public selectedDisposition: Disposition
   public today = new Date()
   public selectedCampaign: CampaignInfo
   public selectedCampaignName: string
   public campaigns: CampaignInfo[]
   public callHistory: CallLogHistoryItem[]
   public currentPractice: number = undefined
   public callNotes: string

   textDispositions = signal<Disposition[]>(undefined)
   callDispositions = signal<Disposition[]>(undefined)

   public phoneNumbers: PhoneNumber[]

   constructor(private callsApiClient: CallsApiClient, private route: ActivatedRoute, private router: Router) {
      this.phoneNumbers = []
   }

   ngOnInit(): void {
      let id = +this.route.snapshot.paramMap.get('campaignId')
      this.selectedCampaign = { id: id } as any
      this.currentPractice = +this.route.snapshot.paramMap.get('practiceId')
      if (this.currentPractice === 0) {
         this.currentPractice = undefined
      }
      this.loadDispositions()
      this.loadNextCall()
      this.loadCampaignInfo()
   }

   loadDispositions() {
      this.callsApiClient.getDispositions().subscribe((r) => {
         if (r.success) {
            this.callDispositions.set(r.result.filter((g) => !g.isSms))
            this.textDispositions.set(r.result.filter((g) => g.isSms))
         }
      })
   }

   loadCampaignInfo() {
      let id = +this.route.snapshot.paramMap.get('campaignId')
      this.callsApiClient
         .getCampaigns(this.currentPractice)
         .pipe(first())
         .subscribe((r) => {
            const campaign = r.result.find((c) => c.id === id)
            this.selectedCampaignName = campaign.name

            if (r.success) {
               this.campaigns = r.result
            }
         })
   }

   loadNextCall() {
      this.isLoading = true
      this.callNotes = ''
      this.callsApiClient.getNextCall(this.selectedCampaign.id, this.currentPractice).subscribe((r) => {
         if (r.success) {
            console.log(r)
            this.callLog = r.result
            this.selectedDisposition = undefined
            this.client = r.result && r.result.client
            this.selectedCampaign = r.result.campaignInfo
            this.phoneNumbers = []
            this.addPhoneNumber(this.client.mobilePhone, 'Mobile')
            this.addPhoneNumber(this.client.homePhone, 'Home')
            this.addPhoneNumber(this.client.workPhone, 'Work')

            this.loadCallHistory()
         }
         this.isLoading = false
      })
   }

   addPhoneNumber(phone: string, type: string) {
      if (!!phone && !this.phoneNumbers.some((p) => p.number == phone)) {
         this.phoneNumbers.push({ number: phone, type: type })
      }
   }

   loadCallHistory() {
      this.callsApiClient.getCallLogs(this.currentPractice, this.client.clientSKey).subscribe((r) => {
         if (r.success) {
            //filter out items where disposition is null or empty
            this.callHistory = r.result
               .filter((item) => item.disposition && item.disposition.trim() !== '')
               .sort((a, b) => new Date(b.callTime).getTime() - new Date(a.callTime).getTime())
         }
      })
   }

   selectNewCampaign() {
      this.router.navigateByUrl('/tail-o-phone')
   }

   onSetDisposition(callDisposition: Disposition) {
      this.selectedDisposition = callDisposition
      this.callLog.dispositionId = callDisposition.id
      console.log(this.callLog.dispositionId)
   }

   onNext() {
      this.isLoading = true
      this.callsApiClient
         .setDisposition({
            id: this.callLog.id,
            disposition: this.callLog.dispositionId,
            notes: this.callNotes,
         })
         .subscribe((r) => {
            if (r.success) this.loadNextCall()
            else this.isLoading = false
         })
   }

   hasNextAppointment(pat: Patient) {
      return pat.nextAppointment != null
   }

   hasRemindersOnAlert(pat: Patient, forCampaign: boolean) {
      return pat.reminders.some((r) => this.isReminderOnAlert(r, forCampaign))
   }

   isReminderOnAlert(reminder: Reminder, forCampaign: boolean) {
      return forCampaign
         ? moment(reminder.pastDueDate) >= moment(this.selectedCampaign.pastDueDateStart) &&
              moment(reminder.pastDueDate) <= moment(this.selectedCampaign.pastDueDateEnd)
         : moment(reminder.pastDueDate) < moment()
   }
}
